import styled from "styled-components";

import { colorsPalettes, setFontVariant } from "@similarweb/styles";
import { BannerTrial, PromoBanner } from "@similarweb/ui-components";
import { Stack } from "@similarweb/ui-components/foundations";

export const StyledUpgradeBannerWrapper = styled(Stack)`
    width: 284px;
    gap: 16px;
`;

export const StyledBannerTrial = styled(BannerTrial)`
    padding: 10px 16px 16px 16px;
    margin-bottom: 0;

    p {
        &:first-of-type {
            margin-bottom: 4px;
            ${setFontVariant("subtitle1", colorsPalettes.indigo[300])};
        }

        &:last-of-type {
            ${setFontVariant("body2", colorsPalettes.indigo[300])};
            margin-bottom: 12px;
        }
    }
`;

export const StyledRowPromoBanner = styled(PromoBanner)`
    background-color: ${colorsPalettes.sky[100]};
    padding: 16px 24px;

    span {
        color: ${colorsPalettes.indigo[300]};
    }
`;
